import PropTypes from 'prop-types';
import React from 'react';

function InternalTabList(props) {
  const { children } = props;

  return (
    <div className="tabbedcontent__tab-list">
      { children }
    </div>
  );
}

InternalTabList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InternalTabList;
